import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Store } from "@ngrx/store";
import { FeatureService } from "./feature.service";
import * as fromAuth from "../../../store/auth";
import { updateUser } from "../../../store/auth";
import { withLatestFrom } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  features$ = this.store.select(fromAuth.selectFeatures);
  private readonly shown = new BehaviorSubject<boolean>(false);
  public readonly shown$ = this.shown.asObservable();

  constructor(private store: Store<{ auth: fromAuth.AuthState }>, private feature: FeatureService) {
    this.features$.subscribe(features => this.shown.next(features.length > 0));
  }

  dismiss() {
    this.feature.dismiss().pipe(
      withLatestFrom(this.store.select(fromAuth.selectUser), this.store.select(fromAuth.selectIsImpersonated))
    ).subscribe(([_, user, isImpersonated]) => {
      this.shown.next(false);
      if (!isImpersonated && user) this.store.dispatch(updateUser({ user: { ...user, lastOnboardedAt: new Date() } }));
    });
  }
}
